export default "__VITE_ASSET__Di3P$$um__"